// context/CustomDataContext.tsx
import React, { createContext, useState, useEffect, useContext } from 'react';
import { apiGetCustom } from '../../request/api';

type CustomDataItem = {
  code: string;
  value: string;
  [key: string]: any;
};

interface CustomDataContextType {
  customData: CustomDataItem[];
  getValue: (code: string) => string | undefined;
}

const CustomDataContext = createContext<CustomDataContextType | undefined>(undefined);

export const CustomDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [customData, setCustomData] = useState<CustomDataItem[]>([]);
  const languageCode = localStorage.getItem('siteLanguage') || 'zh';

  useEffect(() => {
    apiGetCustom({
      pageId: '5A711777462348DDB9B577745DE444AD',
      languageCode,
      size:100
    }).then((res: { data: { data:  React.SetStateAction<CustomDataItem[]>; };  }) => {
      console.log(res)
      setCustomData(res.data.data);
    });
  }, []);

  const getValue = (code: string) => {
    return customData.find(item => item.code === code)?.value;
  };

  return (
    <CustomDataContext.Provider value={{ customData, getValue }}>
      {children}
    </CustomDataContext.Provider>
  );
};

export const useCustomData = (): CustomDataContextType => {
  const context = useContext(CustomDataContext);
  if (!context) {
    throw new Error('useCustomData must be used within a CustomDataProvider');
  }
  return context;
};
